export const KILOBYTE = 1024
export const MEGABYTE = 1048576
export const ATTACHMENTLIMIT_MB = 10
export const MASSUPLOADLIMIT_MB = 1
